/* Project Kennel: side cart. Takes over forms marked data-kcart and the header cart icon. */
(function () {
  var root, panel, busy = false, lastFocus = null, own = 0;
  function $(s, r) { return (r || root).querySelector(s); }
  function money(c) { try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: root.dataset.currency || 'USD' }).format(c / 100); } catch (e) { return '$' + (c / 100).toFixed(2); } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function img(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function msg(t) { var m = $('[data-kcart-msg]'); m.textContent = t || ''; m.hidden = !t; }
  function setCount(n) {
    $('[data-kcart-count]').textContent = n ? '(' + n + ')' : '';
    document.querySelectorAll('.ks-icon--cart').forEach(function (a) {
      a.setAttribute('aria-label', 'Cart, ' + n + ' items');
      var c = a.querySelector('.ks-count');
      if (n > 0) { if (!c) { c = document.createElement('span'); c.className = 'ks-count'; a.appendChild(c); } c.textContent = n; } else if (c) { c.remove(); }
    });
  }
  function render(cart) {
    var list = $('[data-kcart-items]'), empty = cart.item_count === 0;
    $('[data-kcart-empty]').hidden = !empty; $('[data-kcart-foot]').hidden = empty;
    list.innerHTML = cart.items.map(function (it) {
      var plan = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan ? it.selling_plan_allocation.selling_plan.name : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      return '<li class="kcart__it" data-key="' + esc(it.key) + '">' +
        '<a class="kcart__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 160)) + '" alt="" width="80" height="80" loading="lazy">' : '') + '</a>' +
        '<div class="kcart__d"><a href="' + esc(it.url) + '"><b>' + esc(it.product_title) + '</b></a>' +
        (variant ? '<small>' + esc(variant) + '</small>' : '') + (plan ? '<small class="kcart__plan">↻ ' + esc(plan) + '</small>' : '') +
        '<div class="kcart__q"><button type="button" data-q="' + (it.quantity - 1) + '" aria-label="Remove one">−</button><span aria-live="polite">' + it.quantity + '</span><button type="button" data-q="' + (it.quantity + 1) + '" aria-label="Add one">+</button>' +
        '<button type="button" class="kcart__rm" data-q="0">Remove</button></div></div>' +
        '<div class="kcart__p">' + was + '<b>' + money(it.final_line_price) + '</b></div></li>';
    }).join('');
    $('[data-kcart-total]').textContent = money(cart.total_price);
    var free = parseInt(root.dataset.free || '0', 10), ship = $('[data-kcart-ship]');
    if (free > 0 && !empty) {
      var left = free - cart.total_price; ship.hidden = false;
      $('[data-kcart-ship-text]').innerHTML = left > 0 ? 'You’re <b>' + money(left) + '</b> away from free shipping.' : '<b>Free shipping</b> unlocked.';
      $('[data-kcart-bar]').style.width = Math.min(100, Math.round(cart.total_price / free * 100)) + '%';
    } else ship.hidden = true;
    setCount(cart.item_count);
  }
  function load() { return fetch(root.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(render); }
  function open() {
    lastFocus = document.activeElement; root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden'; panel.focus();
  }
  function close() {
    if (root.hidden) return; root.classList.remove('is-open'); document.documentElement.style.overflow = '';
    setTimeout(function () { root.hidden = true; }, 250); if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function change(key, q) {
    if (busy) return; busy = true; root.classList.add('is-busy');
    fetch(root.dataset.changeUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
      .then(function (r) { return r.json(); }).then(function (c) { msg(''); if (c && c.items) render(c); else load(); })
      .catch(function () { msg('Something went wrong. Please try again.'); })
      .then(function () { busy = false; root.classList.remove('is-busy'); });
  }
  function add(form, btn) {
    if (busy) return; busy = true; if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    own++;
    fetch(root.dataset.addUrl + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .finally(function () { own--; })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) { return load().then(function () { msg(res.ok ? '' : (res.j && (res.j.description || res.j.message)) || 'That couldn’t be added.'); open(); }); })
      .catch(function () { form.submit(); })
      .then(function () { busy = false; if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  }

  /* Other add-to-cart code on the site (old theme pages, apps): open the side cart once their add succeeds. */
  function isAdd(u) { return /\/cart\/add(\.js)?(\?|$)/.test(String(u || '')); }
  var opening = null;
  function external() {
    if (!root || own > 0) return;
    clearTimeout(opening); opening = setTimeout(function () { load().then(function () { msg(''); open(); }).catch(function () {}); }, 250);
  }
  if (window.fetch) {
    var _f = window.fetch;
    window.fetch = function (input, init) {
      var u = typeof input === 'string' ? input : (input && input.url);
      var p = _f.apply(this, arguments);
      if (isAdd(u) && own === 0) p.then(function (r) { if (r && r.ok) external(); }).catch(function () {});
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open, _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this._kcAdd = isAdd(u); return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (this._kcAdd && own === 0) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) external(); });
    return _send.apply(this, arguments);
  };
  function init() {
    root = document.querySelector('[data-kcart-root]'); if (!root) return; if (root.parentElement !== document.body) document.body.appendChild(root); panel = $('.kcart__panel');
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-kcart-close]')) { e.preventDefault(); close(); return; }
      var q = e.target.closest('[data-q]'); if (q) { var li = q.closest('[data-key]'); change(li.dataset.key, parseInt(q.dataset.q, 10)); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('submit', function (e) {
      var f = e.target; if (!f.matches || !f.matches('form[data-kcart]')) return;
      e.preventDefault(); add(f, e.submitter || f.querySelector('[type="submit"]'));
    });
    var onCartPage = location.pathname.replace(/\/$/, '') === root.dataset.cartUrl.replace(/\/$/, '');
    document.addEventListener('click', function (e) {
      var a = e.target.closest('.ks-icon--cart'); if (!a || onCartPage) return;
      e.preventDefault(); load().then(open).catch(function () { location.href = a.href; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
